/** UI + query scope for GET .../merchantSettle (maps to hasPending=true). */

export const SETTLE_LIST_SCOPE = {
  ALL: "all",
  HAS_PENDING_UNSETTLED: "hasPendingUnsettled",
};

export const SETTLE_LIST_SCOPE_OPTIONS = [
  { value: SETTLE_LIST_SCOPE.ALL, label: "Бүх өндөрлөлт" },
  {
    value: SETTLE_LIST_SCOPE.HAS_PENDING_UNSETTLED,
    label: "Шилжүүлээгүй гүйлгээтэй",
  },
];

/** @param {string} scope @returns {boolean} */
export function settleListScopeToHasPending(scope) {
  return scope === SETTLE_LIST_SCOPE.HAS_PENDING_UNSETTLED;
}
